import { Injectable } from '@angular/core';

declare const logoutApp;

declare global {
    interface Window {
        webkit: any;
    }
}

@Injectable({ providedIn: 'root' })
export class LogoutAppService {


    returnCommunicator(): void {
        /**
         * Send mensage for IOS or Android
         */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logoutApp) {
            this.comunicationIos();
        } else {
            this.comunicationAndroid();
        }
    }

    private comunicationIos() {
        window.webkit.messageHandlers.logoutApp.postMessage({
            param: 'logoutApp'
        });
    }

    private comunicationAndroid() {
        const param = 'logoutApp';
        try {
            logoutApp.postMessage(param);
        } catch (error) {
        }
    }
}

